export enum OptionValueType {
    VALUE = 1,
    SUB_CATALOG = 2,
}

export enum LevelEnum {
    CATEGORY = 1,
    SUB_CATEGORY = 2,
    DROP_LIST = 3
}